(function () {
  'use strict';

  var CONFIG = {
    startHour: 0,        // 12:00 AM (Opening time / 24-hour full day coverage)
    endHour: 24,         // 12:00 AM / Midnight (Closing time)
    leadBufferHours: 2,  // 2-hour lead buffer from current time
    daysAhead: 7         // Number of days to show in date dropdown
  };

  function formatHour(h) {
    var normalized = h % 24;
    var period = normalized >= 12 && normalized < 24 ? 'PM' : 'AM';
    var hour12 = normalized % 12;
    if (hour12 === 0) hour12 = 12;
    return hour12 + ':00 ' + period;
  }

  function getSlotLabel(startH, endH) {
    return formatHour(startH) + ' - ' + formatHour(endH);
  }

  function getClosedDaysMap(container) {
    return {
      0: container.dataset.closedSunday === 'true',
      1: container.dataset.closedMonday === 'true',
      2: container.dataset.closedTuesday === 'true',
      3: container.dataset.closedWednesday === 'true',
      4: container.dataset.closedThursday === 'true',
      5: container.dataset.closedFriday === 'true',
      6: container.dataset.closedSaturday === 'true'
    };
  }

  function getSpecificClosedDates(container) {
    var raw = container.dataset.closedDates || '';
    if (!raw.trim()) return [];
    return raw.split(',').map(function (s) {
      return s.trim();
    }).filter(Boolean);
  }

  function formatDateISO(d) {
    var year = d.getFullYear();
    var month = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function isDateClosed(d, container) {
    var closedDays = getClosedDaysMap(container);
    if (closedDays[d.getDay()]) {
      return true;
    }
    var specificDates = getSpecificClosedDates(container);
    var iso = formatDateISO(d);
    return specificDates.indexOf(iso) !== -1;
  }

  function getAvailableSlots(dateIndex, container, customNow) {
    var now = customNow || new Date();
    var targetDate = new Date(now);
    targetDate.setDate(now.getDate() + dateIndex);

    // If store is closed on target date, no slots available
    if (container && isDateClosed(targetDate, container)) {
      return [];
    }

    var currentHour = now.getHours();
    if (now.getMinutes() > 0 || now.getSeconds() > 0) {
      currentHour += 1;
    }
    var slots = [];

    var startSlotHour = CONFIG.startHour;
    var endSlotHour = CONFIG.endHour;

    if (dateIndex === 0) {
      // Today: slots start at least (currentHour + leadBufferHours)
      var earliestHour = currentHour + CONFIG.leadBufferHours;
      startSlotHour = Math.max(CONFIG.startHour, earliestHour);

      // If earliestHour >= endHour (e.g. 10 PM + 2h = 24), no slots left today
      if (startSlotHour >= endSlotHour) {
        return [];
      }
    }

    for (var h = startSlotHour; h < endSlotHour; h++) {
      var label = getSlotLabel(h, h + 1);
      slots.push({
        value: label,
        label: label
      });
    }

    return slots;
  }

  function formatDate(d, index) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var dayName = days[d.getDay()];
    var monthName = months[d.getMonth()];
    var dateNum = d.getDate();
    var dateString = dayName + ', ' + monthName + ' ' + dateNum;

    var prefix = '';
    if (index === 0) prefix = 'Today - ';
    else if (index === 1) prefix = 'Tomorrow - ';

    return {
      value: dateString,
      display: prefix + dateString
    };
  }

  function initPickupSlot() {
    var container = document.getElementById('CartPickupSlot');
    if (!container) return;

    var toggle = container.querySelector('#CartPickupToggle');
    var dateSelect = container.querySelector('#CartPickupDate');
    var timeSelect = container.querySelector('#CartPickupTime');
    var hiddenDateInput = document.getElementById('CartDrawer-PickupDate');
    var hiddenTimeInput = document.getElementById('CartDrawer-PickupTime');
    var hiddenDeliveryOption = document.getElementById('CartDrawer-DeliveryOption');
    var badgeEl = container.querySelector('.cart-pickup-slot__badge');

    if (!dateSelect || !timeSelect || !toggle) return;

    // Prevent any change events from bubbling up to CartItems
    container.addEventListener('change', function (e) {
      e.stopPropagation();
    });

    var now = new Date();
    var todayIsClosed = isDateClosed(now, container);
    var todaySlots = todayIsClosed ? [] : getAvailableSlots(0, container, now);
    var todayHasSlots = todaySlots.length > 0;

    // Read stored attributes from container dataset or inputs
    var storedDate = container.dataset.currentDate || (hiddenDateInput ? hiddenDateInput.value : '');
    var storedTime = container.dataset.currentTime || (hiddenTimeInput ? hiddenTimeInput.value : '');

    // Checkbox initial state based on stored attributes or existing checked
    if (storedDate && storedTime) {
      toggle.checked = true;
      container.classList.add('is-active');
      if (badgeEl) badgeEl.style.display = 'inline-block';
    }

    // Populate Date Options
    dateSelect.innerHTML = '';
    var firstAvailableIndex = -1;

    for (var i = 0; i < CONFIG.daysAhead; i++) {
      var d = new Date(now);
      d.setDate(now.getDate() + i);
      var formatted = formatDate(d, i);
      var isClosed = isDateClosed(d, container);
      var slotsForDate = getAvailableSlots(i, container, now);
      var hasSlots = slotsForDate.length > 0;

      var opt = document.createElement('option');
      opt.value = formatted.value;
      opt.dataset.index = i;

      if (isClosed) {
        opt.textContent = formatted.display + ' (Store Closed)';
        opt.disabled = true;
      } else if (i === 0 && !hasSlots) {
        opt.textContent = formatted.display + ' (No slots left)';
        opt.disabled = true;
      } else {
        opt.textContent = formatted.display;
        if (firstAvailableIndex === -1) {
          firstAvailableIndex = i;
        }
      }

      dateSelect.appendChild(opt);
    }

    // Determine selected date
    var matchingDateOpt = null;
    if (storedDate) {
      for (var j = 0; j < dateSelect.options.length; j++) {
        if (!dateSelect.options[j].disabled && dateSelect.options[j].value === storedDate) {
          matchingDateOpt = dateSelect.options[j];
          break;
        }
      }
    }

    if (matchingDateOpt) {
      dateSelect.value = matchingDateOpt.value;
    } else if (firstAvailableIndex !== -1) {
      for (var k = 0; k < dateSelect.options.length; k++) {
        if (parseInt(dateSelect.options[k].dataset.index, 10) === firstAvailableIndex) {
          dateSelect.selectedIndex = k;
          break;
        }
      }
    }

    // Populate time slots based on selected date
    function updateTimeOptions(preserveStored) {
      var selectedOption = dateSelect.options[dateSelect.selectedIndex];
      var dateIdx = selectedOption ? parseInt(selectedOption.dataset.index, 10) : 0;
      var slots = getAvailableSlots(dateIdx, container, new Date());

      timeSelect.innerHTML = '';

      if (slots.length === 0) {
        var emptyOpt = document.createElement('option');
        emptyOpt.value = '';
        emptyOpt.textContent = 'No slots available';
        timeSelect.appendChild(emptyOpt);
        timeSelect.disabled = true;
        return;
      }

      timeSelect.disabled = false;
      var foundStored = false;

      slots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot.value;
        opt.textContent = slot.label;
        if (preserveStored && slot.value === storedTime) {
          opt.selected = true;
          foundStored = true;
        }
        timeSelect.appendChild(opt);
      });

      if (!foundStored && slots.length > 0) {
        timeSelect.selectedIndex = 0;
      }

      if (badgeEl && toggle.checked) {
        if (dateIdx === 0 && todayHasSlots) {
          badgeEl.textContent = 'Available Today';
          badgeEl.style.display = 'inline-block';
        } else if (dateIdx === 1) {
          badgeEl.textContent = 'Tomorrow';
          badgeEl.style.display = 'inline-block';
        } else {
          badgeEl.textContent = 'Scheduled';
          badgeEl.style.display = 'inline-block';
        }
      }

      if (toggle.checked) {
        savePickupAttributes();
      }
    }

    // Save or clear selected attributes to Cart
    var isSaving = false;
    var currentSavePromise = null;

    function savePickupAttributes() {
      var isChecked = toggle.checked;
      var selectedDate = isChecked ? dateSelect.value : '';
      var selectedTime = isChecked ? timeSelect.value : '';
      var deliveryOpt = isChecked ? 'Pickup' : '';

      if (hiddenDateInput) hiddenDateInput.value = selectedDate;
      if (hiddenTimeInput) hiddenTimeInput.value = selectedTime;
      if (hiddenDeliveryOption) hiddenDeliveryOption.value = deliveryOpt;

      container.dataset.currentDate = selectedDate;
      container.dataset.currentTime = selectedTime;

      isSaving = true;
      container.classList.add('cart-pickup-slot__saving');

      var rootUrl = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

      currentSavePromise = fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Pickup Date': selectedDate,
            'Pickup Time': selectedTime,
            'Delivery Option': deliveryOpt,
            'Pickup Type': deliveryOpt
          }
        })
      })
        .then(function (res) { return res.json(); })
        .catch(function (err) {
          console.warn('[CartPickup] update error', err);
        })
        .finally(function () {
          isSaving = false;
          container.classList.remove('cart-pickup-slot__saving');
        });

      return currentSavePromise;
    }

    // Ensure checkout waits for any pending attribute saves
    function handleCheckoutClick(e) {
      if (isSaving && currentSavePromise) {
        e.preventDefault();
        currentSavePromise.finally(function () {
          var form = document.getElementById('CartDrawer-Form') || document.getElementById('cart');
          if (form) {
            form.submit();
          } else {
            window.location.href = '/checkout';
          }
        });
      }
    }

    var checkoutBtns = document.querySelectorAll('#CartDrawer-Checkout, #checkout, [name="checkout"]');
    checkoutBtns.forEach(function (btn) {
      btn.removeEventListener('click', handleCheckoutClick);
      btn.addEventListener('click', handleCheckoutClick);
    });

    // Event listener for Checkbox Toggle
    toggle.onchange = function (e) {
      if (e) e.stopPropagation();
      if (toggle.checked) {
        container.classList.add('is-active');
        if (badgeEl) badgeEl.style.display = 'inline-block';
        updateTimeOptions(true);
      } else {
        container.classList.remove('is-active');
        if (badgeEl) badgeEl.style.display = 'none';
        savePickupAttributes();
      }
    };

    // Event listeners for Selects
    dateSelect.onchange = function (e) {
      if (e) e.stopPropagation();
      updateTimeOptions(false);
    };

    timeSelect.onchange = function (e) {
      if (e) e.stopPropagation();
      if (toggle.checked) {
        savePickupAttributes();
      }
    };

    // Initial setup
    updateTimeOptions(true);
  }

  // Bind to events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickupSlot);
  } else {
    setTimeout(initPickupSlot, 50);
  }

  // Subscribe to Dawn pub/sub cart updates
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(initPickupSlot, 100);
    });
  }

  // Re-init on drawer render or cart changes
  document.addEventListener('cartDrawerContentRendered', function () {
    setTimeout(initPickupSlot, 50);
  });
  document.addEventListener('cart:updated', function () {
    setTimeout(initPickupSlot, 50);
  });
  document.addEventListener('cart:refresh', function () {
    setTimeout(initPickupSlot, 50);
  });

  // Also hook into drawer opening
  var drawerObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var drawer = mutation.target;
        if (drawer.classList.contains('active')) {
          setTimeout(initPickupSlot, 50);
        }
      }
    });
  });

  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    drawerObserver.observe(drawerEl, { attributes: true });
  }

  window.initCartPickupSlot = initPickupSlot;
})();
